module.exports = __webpack_public_path__ + "assets/img/0_05.789c66e8.png";